import React from 'react';

import HandsRaisedIcon from '../assets/hands_raised.svg';
import MapIcon from '../assets/map.svg';

const infoSections = [
  {
    icon: <img src={HandsRaisedIcon} alt="Hands raised in the air" />,
    name: 'SAT Score Improvement Made Easy',
    text: 'Magoosh has high quality practice questions, full-length practice tests, expert video lessons, custom study schedules and more.'
  },
  {
    icon: <img src={MapIcon} alt="Map showing a path to follow" />,
    name: 'Plus! 24/7 Student Support',
    text: 'Quick email and chat support from our test prep experts when you get stuck or just want some extra help.'
  }
];

export default { infoSections };
